


















import { IJobMatchPage } from '@app/componentlib/common/types/JobMatchTypes'
import Vue from 'vue'
import Component from 'vue-class-component'
import JobMatchResultContainer from './result-page/JobMatchResultContainer.vue'
import StartPage from './start-page/StartPage.vue'

import { AppModule } from '@app/componentlib/src/store/modules/app'
import { ISettingsItem, IUserInfo } from '@app/componentlib/common/types/JobSearchTypes'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'

@Component<JobMatchPage>({
  components: {
    JobMatchResultContainer,
    StartPage
  },
  props: {
    title: String,
    translations: Object,
    content: Object,
    userInfo: Object,
    jobAdvertId: Number,
    settings: Object,
    jobApplicationAccess: Boolean
  }
})

export default class JobMatchPage extends Vue {
  /**
   * Props variables
   */
  title: string | undefined
  translations: object | undefined
  content: IJobMatchPage | undefined
  userInfo: IUserInfo | undefined
  jobAdvertId: number | undefined
  settings: ISettingsItem | undefined
  jobApplicationAccess: boolean | undefined
  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */
  async mounted () {
    JobMatchModule.setDeepLinkJobId(this.jobAdvertId !== undefined ? this.jobAdvertId : 0)

    if (this.translations !== undefined) await AppModule.setTranslations(this.translations)
    await JobSearchModule.setUserInfo(this.userInfo!)
    await JobMatchModule.init(this.userInfo!)
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get showResultPage () {
    return JobMatchModule.showResultPage
  }

  get initialized () {
    return JobMatchModule.initialized
  }

  /**
   * Methods
   */

}
